<micro-select-combo #sel
              placeholder="ITSM Carrier"
              routerBase="task/itsmCarriers"
              [mode]="mode"
              [(id)]="itsmCarrierId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              platformService="taskd"
>
</micro-select-combo>
